import Navbars from "./nav.js";
import Create from "./create.js";
import userContext from "./context.js";
import { HashRouter, Routes, Route } from "react-router-dom";
import Home from "./home.js";
import Deposit from "./deposit.js";
import Withdraw from "./withdraw.js";
import Alldata from "./alldata.js";
import './badbank.css';

export default function App() {
  return (
    <>
      <HashRouter>
        <userContext.Provider
          value={{
            users: [
              {
                Name: "xyz",
                email: "xyz@gmail.com",
                password: "xyz",
                balance: 100
              },
            ]
          }}
        >
          <Navbars />
          <Routes>
          <Route path="/" element={<Home />} />
            <Route path="/create" element={<Create />} />
            <Route path="/deposit" element={<Deposit />} />
            <Route path="/withdraw" element={<Withdraw />} />
            <Route path="/alldata" element={<Alldata />} />
          </Routes>
        </userContext.Provider>
      </HashRouter>
    </>
  );
}

